import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { FaLock } from "react-icons/fa";
export default function SetPassword() {
  const { user, loginCtx } = useAuth();
  const navigate = useNavigate();
  const [form,    setForm]    = useState({ current_password: "", new_password: "", confirm: "" });
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password !== form.confirm)
      return setError("Las contraseñas no coinciden.");
    if (form.new_password.length < 6)
      return setError("La nueva contraseña debe tener al menos 6 caracteres.");
    if (form.current_password === form.new_password)
      return setError("La nueva contraseña debe ser diferente a la actual.");
    setLoading(true);
    try {
      await changePassword({ current_password: form.current_password, new_password: form.new_password });
      // Actualizar el user en contexto para quitar el flag
      loginCtx(localStorage.getItem("token"), { ...user, must_change_password: false });
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem" }}>
      <div style={{ background:"var(--white)", border:"0.5px solid var(--border)", borderRadius:12, padding:"2.5rem 2rem", width:"100%", maxWidth:420 }}>

        {/* Ícono + título */}
        <div style={{ textAlign:"center", marginBottom:"1.5rem" }}>
          <FaLock size={36} color="var(--teal)" />
          <h1 style={{ fontFamily:"var(--font-display)", fontWeight:800, fontSize:"1.2rem", color:"var(--teal-dark)", letterSpacing:1 }}>
            ESTABLECE TU CONTRASEÑA
          </h1>
          <p style={{ fontSize:"0.82rem", color:"var(--text-muted)", marginTop:".5rem", lineHeight:1.5 }}>
            Bienvenido/a, <strong>{user?.first_name}</strong>. Por seguridad, debes crear tu propia contraseña antes de continuar.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Contraseña temporal (tu código)</label>
            <input
              name="current_password"
              type="password"
              value={form.current_password}
              onChange={handleChange}
              placeholder="Ingresa tu contraseña temporal"
              required
            />
          </div>
          <div className="form-group">
            <label>Nueva contraseña</label>
            <input
              name="new_password"
              type="password"
              value={form.new_password}
              onChange={handleChange}
              placeholder="Mínimo 6 caracteres"
              required
            />
          </div>
          <div className="form-group">
            <label>Confirmar nueva contraseña</label>
            <input
              name="confirm"
              type="password"
              value={form.confirm}
              onChange={handleChange}
              placeholder="Repite la nueva contraseña"
              required
            />
          </div>

          {error && <p className="form-error">{error}</p>}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            style={{ width:"100%", padding:"10px", marginTop:".5rem", fontSize:"0.85rem" }}
          >
            {loading ? "Guardando..." : "Establecer contraseña"}
          </button>
        </form>
      </div>
    </div>
  );
}
